import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var ACTION = /*#__PURE__*/function (ACTION) {
  ACTION["TOGGLE_DISABLED"] = "TOGGLE_DISABLED";
  return ACTION;
}({});
export function reducer(pluginState, meta) {
  if (meta && 'action' in meta) {
    switch (meta.action) {
      case ACTION.TOGGLE_DISABLED:
        if (meta.disabled === pluginState.disabledByPlugin) {
          return pluginState;
        }
        return _objectSpread(_objectSpread({}, pluginState), {}, {
          disabledByPlugin: Boolean(meta.disabled)
        });
      default:
        return pluginState;
    }
  }
  return pluginState;
}